import { api } from '@/scripts/api';

export const ActivityTypesService = {
    getAll(accountId, options = {},) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/activity-types/account/${accountId}?include=["ProofModel"]&${options}`;
            
            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    getById(accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/activity-types/account/${accountId}?include=["ProofModel"]`;

            api.get(service)
                .then(resolve)
                .catch(reject);
        });
    },

    post(payload, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/activity-types/account/${accountId}`;

            api
                .post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    put(id, accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/activity-types/${id}/account/${accountId}`;

            api.put(service, payload)
                .then(resolve)
                .catch(reject);
        });

    },

    delete(id, accountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/activity-types/${id}/account/${accountId}`;

            api
                .delete(service)
                .then(resolve)
                .catch(reject);
        });
    },
}
